import React, { Component } from 'react';
import { showPreloader } from 'redux/modules/preloader';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Button from '@material-ui/core/Button';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import SelectArrow from '@material-ui/icons/KeyboardArrowDown';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { hideModal, resetModal } from 'redux/modules/modal';
import PropTypes from 'prop-types';
import i18n from 'i18n/i18n';

const localize = i18n.loc.localize;

class CompanySelectionModal extends Component {

	constructor(props) {
		super(props);
		this.goToPage = this.goToPage.bind(this);
		this.state = {
			selectedCompanyId: this.props.companyId
		};
	}

	render() {
		const { modalShown, resetModal } = this.props;
		
		return (
			<Dialog
				open={modalShown}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
				onExited={resetModal}
			>
				{this.renderDialog()}
			</Dialog>
		);
	}

	renderDialog() {
		return (<React.Fragment>
			<DialogContent>
				<DialogContentText variant='body1' color='default'>
					{localize('company-selection-modal-select-team')}
				</DialogContentText>
			</DialogContent>

			<DialogActions>
				{this.renderCompanySelector()}
			</DialogActions>

			<DialogActions>
				<Button
					key='upgrade-company-button'
					data-tid="button-upgrade-company-continue"
					variant='contained'
					color='primary'
					onClick={ this.goToPage }
				>
					{localize('continue')}
				</Button>
			</DialogActions>
		</React.Fragment>);
	}

	renderCompanySelector() {
		const companies = Object.values(this.props.companies.byId);
		return (<Select
			data-tid="upgrade-company-company-selector"
			value={this.state.selectedCompanyId}
			name="company"
			disableUnderline
			IconComponent={SelectArrow}
			onChange={(event) => {
				this.setState({selectedCompanyId: event.target.value});
			}}
		>
			<MenuItem value="" disabled>{localize('company-selection-modal-selector')}</MenuItem>
			{companies.map((company) => {
				return (<MenuItem
					key={company.id}
					value={company.id}
					data-tid={`upgrade-company-item-${company.displayName}`}>
					{company.displayName}
				</MenuItem>);
			})}
		</Select>);
	}

	goToPage() {
		const { redirectURL } = this.props;
		const companyId = this.state ? this.state.selectedCompanyId : this.props.companyId;
		let url = window.location.origin + redirectURL.replace(':companyId', '#' + companyId);
		if (url.indexOf('company-known=1') === -1) {
			url += url.indexOf('?') === -1 ? '/?' : '&';
			url += 'company-known=1';
		}

		window.location.href = url;
		window.location.reload();
		this.props.hideModal();
		this.props.showPreloader();
	}
}

CompanySelectionModal.propTypes = {
	companies: PropTypes.object,
	modalShown: PropTypes.bool,
	hideModal: PropTypes.func,
	resetModal: PropTypes.func,
	companyId: PropTypes.string,
	showPreloader: PropTypes.func,
	redirectURL: PropTypes.string
};

const mapStateToProps = state => ({
	modalShown: state.modal.modalShown,
	companies: state.companies,	
	companyId: state.companies.rawDataById[state.companies.selectedId].id
});

const mapDispatchToProps = dispatch => bindActionCreators({
	hideModal,
	resetModal,
	showPreloader
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(CompanySelectionModal);


// WEBPACK FOOTER //
// ./src/components/Modal/CompanySelectionModal.js